// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file organization.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Contact, ContactJson } from "./contact_pb";
import { file_contact } from "./contact_pb";
import type { OrganizationStatus, OrganizationStatusJson, OrganizationType, OrganizationTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { ListFilter, ListFilterJson, ListInfo, ListInfoJson, UserRef, UserRefJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { OrganizationSettings, OrganizationSettingsJson } from "./organization_settings_pb";
import { file_organization_settings } from "./organization_settings_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file organization.proto.
 */
export const file_organization: GenFile = /*@__PURE__*/
  fileDesc("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", [file_contact, file_enums, file_general, file_google_protobuf_timestamp, file_organization_settings]);

/**
 * @generated from message raccoonai.Organization
 */
export type Organization = Message<"raccoonai.Organization"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string name = 2;
   */
  name: string;

  /**
   * @generated from field: required raccoonai.OrganizationType type = 3;
   */
  type: OrganizationType;

  /**
   * @generated from field: required raccoonai.OrganizationStatus status = 4;
   */
  status: OrganizationStatus;

  /**
   * @generated from field: optional uint64 bank_details_id = 5 [json_name = "bank_details_id"];
   */
  bankDetailsId: bigint;

  /**
   * @generated from field: optional string bin = 6;
   */
  bin: string;

  /**
   * ID of primary org-level contact
   *
   * @generated from field: optional uint64 primary_contact_id = 7 [json_name = "primary_contact_id"];
   */
  primaryContactId: bigint;

  /**
   * @generated from field: optional string jur_address = 8 [json_name = "jur_address"];
   */
  jurAddress: string;

  /**
   * @generated from field: optional string fact_address = 9 [json_name = "fact_address"];
   */
  factAddress: string;

  /**
   * @generated from field: optional raccoonai.Contact primary_contact = 10 [json_name = "primary_contact"];
   */
  primaryContact?: Contact;

  /**
   * @generated from field: optional string director_full_name = 11 [json_name = "director_full_name"];
   */
  directorFullName: string;

  /**
   * @generated from field: optional uint64 parent_id = 12 [json_name = "parent_id"];
   */
  parentId: bigint;

  /**
   * @generated from field: optional raccoonai.Organization parent = 13;
   */
  parent?: Organization;

  /**
   * @generated from field: optional raccoonai.OrganizationSettings organization_settings = 14 [json_name = "organization_settings"];
   */
  organizationSettings?: OrganizationSettings;

  /**
   * @generated from field: optional uint64 manager_id = 15 [json_name = "manager_id"];
   */
  managerId: bigint;

  /**
   * @generated from field: optional raccoonai.UserRef manager = 16;
   */
  manager?: UserRef;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message raccoonai.Organization
 */
export type OrganizationJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string name = 2;
   */
  name?: string;

  /**
   * @generated from field: required raccoonai.OrganizationType type = 3;
   */
  type?: OrganizationTypeJson;

  /**
   * @generated from field: required raccoonai.OrganizationStatus status = 4;
   */
  status?: OrganizationStatusJson;

  /**
   * @generated from field: optional uint64 bank_details_id = 5 [json_name = "bank_details_id"];
   */
  bank_details_id?: string;

  /**
   * @generated from field: optional string bin = 6;
   */
  bin?: string;

  /**
   * ID of primary org-level contact
   *
   * @generated from field: optional uint64 primary_contact_id = 7 [json_name = "primary_contact_id"];
   */
  primary_contact_id?: string;

  /**
   * @generated from field: optional string jur_address = 8 [json_name = "jur_address"];
   */
  jur_address?: string;

  /**
   * @generated from field: optional string fact_address = 9 [json_name = "fact_address"];
   */
  fact_address?: string;

  /**
   * @generated from field: optional raccoonai.Contact primary_contact = 10 [json_name = "primary_contact"];
   */
  primary_contact?: ContactJson;

  /**
   * @generated from field: optional string director_full_name = 11 [json_name = "director_full_name"];
   */
  director_full_name?: string;

  /**
   * @generated from field: optional uint64 parent_id = 12 [json_name = "parent_id"];
   */
  parent_id?: string;

  /**
   * @generated from field: optional raccoonai.Organization parent = 13;
   */
  parent?: OrganizationJson;

  /**
   * @generated from field: optional raccoonai.OrganizationSettings organization_settings = 14 [json_name = "organization_settings"];
   */
  organization_settings?: OrganizationSettingsJson;

  /**
   * @generated from field: optional uint64 manager_id = 15 [json_name = "manager_id"];
   */
  manager_id?: string;

  /**
   * @generated from field: optional raccoonai.UserRef manager = 16;
   */
  manager?: UserRefJson;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.Organization.
 * Use `create(OrganizationSchema)` to create a new message.
 */
export const OrganizationSchema: GenMessage<Organization, {jsonType: OrganizationJson}> = /*@__PURE__*/
  messageDesc(file_organization, 0);

/**
 * @generated from message raccoonai.OrganizationCreateItem
 */
export type OrganizationCreateItem = Message<"raccoonai.OrganizationCreateItem"> & {
  /**
   * @generated from field: required string name = 1;
   */
  name: string;

  /**
   * @generated from field: required raccoonai.OrganizationType type = 2;
   */
  type: OrganizationType;

  /**
   * @generated from field: optional uint64 bank_details_id = 3 [json_name = "bank_details_id"];
   */
  bankDetailsId: bigint;

  /**
   * @generated from field: optional string bin = 4;
   */
  bin: string;

  /**
   * @generated from field: optional string jur_address = 6 [json_name = "jur_address"];
   */
  jurAddress: string;

  /**
   * @generated from field: optional string fact_address = 7 [json_name = "fact_address"];
   */
  factAddress: string;

  /**
   * @generated from field: optional string director_full_name = 8 [json_name = "director_full_name"];
   */
  directorFullName: string;
};

/**
 * @generated from message raccoonai.OrganizationCreateItem
 */
export type OrganizationCreateItemJson = {
  /**
   * @generated from field: required string name = 1;
   */
  name?: string;

  /**
   * @generated from field: required raccoonai.OrganizationType type = 2;
   */
  type?: OrganizationTypeJson;

  /**
   * @generated from field: optional uint64 bank_details_id = 3 [json_name = "bank_details_id"];
   */
  bank_details_id?: string;

  /**
   * @generated from field: optional string bin = 4;
   */
  bin?: string;

  /**
   * @generated from field: optional string jur_address = 6 [json_name = "jur_address"];
   */
  jur_address?: string;

  /**
   * @generated from field: optional string fact_address = 7 [json_name = "fact_address"];
   */
  fact_address?: string;

  /**
   * @generated from field: optional string director_full_name = 8 [json_name = "director_full_name"];
   */
  director_full_name?: string;
};

/**
 * Describes the message raccoonai.OrganizationCreateItem.
 * Use `create(OrganizationCreateItemSchema)` to create a new message.
 */
export const OrganizationCreateItemSchema: GenMessage<OrganizationCreateItem, {jsonType: OrganizationCreateItemJson}> = /*@__PURE__*/
  messageDesc(file_organization, 1);

/**
 * @generated from message raccoonai.ContractCreateItem
 */
export type ContractCreateItem = Message<"raccoonai.ContractCreateItem"> & {
  /**
   * @generated from field: required google.protobuf.Timestamp end_at = 1 [json_name = "end_at"];
   */
  endAt?: Timestamp;
};

/**
 * @generated from message raccoonai.ContractCreateItem
 */
export type ContractCreateItemJson = {
  /**
   * @generated from field: required google.protobuf.Timestamp end_at = 1 [json_name = "end_at"];
   */
  end_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.ContractCreateItem.
 * Use `create(ContractCreateItemSchema)` to create a new message.
 */
export const ContractCreateItemSchema: GenMessage<ContractCreateItem, {jsonType: ContractCreateItemJson}> = /*@__PURE__*/
  messageDesc(file_organization, 2);

/**
 * @generated from message raccoonai.OrganizationCreate
 */
export type OrganizationCreate = Message<"raccoonai.OrganizationCreate"> & {
  /**
   * @generated from field: required string name = 1;
   */
  name: string;

  /**
   * @generated from field: required raccoonai.OrganizationType type = 2;
   */
  type: OrganizationType;

  /**
   * @generated from field: optional string bin = 3;
   */
  bin: string;

  /**
   * @generated from field: optional string jur_address = 4 [json_name = "jur_address"];
   */
  jurAddress: string;

  /**
   * @generated from field: optional string fact_address = 5 [json_name = "fact_address"];
   */
  factAddress: string;

  /**
   * @generated from field: optional string director_full_name = 6 [json_name = "director_full_name"];
   */
  directorFullName: string;

  /**
   * @generated from field: optional uint64 parent_id = 7 [json_name = "parent_id"];
   */
  parentId: bigint;

  /**
   * @generated from field: optional uint64 manager_id = 8 [json_name = "manager_id"];
   */
  managerId: bigint;
};

/**
 * @generated from message raccoonai.OrganizationCreate
 */
export type OrganizationCreateJson = {
  /**
   * @generated from field: required string name = 1;
   */
  name?: string;

  /**
   * @generated from field: required raccoonai.OrganizationType type = 2;
   */
  type?: OrganizationTypeJson;

  /**
   * @generated from field: optional string bin = 3;
   */
  bin?: string;

  /**
   * @generated from field: optional string jur_address = 4 [json_name = "jur_address"];
   */
  jur_address?: string;

  /**
   * @generated from field: optional string fact_address = 5 [json_name = "fact_address"];
   */
  fact_address?: string;

  /**
   * @generated from field: optional string director_full_name = 6 [json_name = "director_full_name"];
   */
  director_full_name?: string;

  /**
   * @generated from field: optional uint64 parent_id = 7 [json_name = "parent_id"];
   */
  parent_id?: string;

  /**
   * @generated from field: optional uint64 manager_id = 8 [json_name = "manager_id"];
   */
  manager_id?: string;
};

/**
 * Describes the message raccoonai.OrganizationCreate.
 * Use `create(OrganizationCreateSchema)` to create a new message.
 */
export const OrganizationCreateSchema: GenMessage<OrganizationCreate, {jsonType: OrganizationCreateJson}> = /*@__PURE__*/
  messageDesc(file_organization, 3);

/**
 * @generated from message raccoonai.ServiceReceiverCreate
 */
export type ServiceReceiverCreate = Message<"raccoonai.ServiceReceiverCreate"> & {
  /**
   * @generated from field: required raccoonai.OrganizationCreateItem organization = 1;
   */
  organization?: OrganizationCreateItem;

  /**
   * @generated from field: optional raccoonai.ContractCreateItem contract = 2;
   */
  contract?: ContractCreateItem;

  /**
   * @generated from field: optional uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: optional string bin = 4;
   */
  bin: string;
};

/**
 * @generated from message raccoonai.ServiceReceiverCreate
 */
export type ServiceReceiverCreateJson = {
  /**
   * @generated from field: required raccoonai.OrganizationCreateItem organization = 1;
   */
  organization?: OrganizationCreateItemJson;

  /**
   * @generated from field: optional raccoonai.ContractCreateItem contract = 2;
   */
  contract?: ContractCreateItemJson;

  /**
   * @generated from field: optional uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: optional string bin = 4;
   */
  bin?: string;
};

/**
 * Describes the message raccoonai.ServiceReceiverCreate.
 * Use `create(ServiceReceiverCreateSchema)` to create a new message.
 */
export const ServiceReceiverCreateSchema: GenMessage<ServiceReceiverCreate, {jsonType: ServiceReceiverCreateJson}> = /*@__PURE__*/
  messageDesc(file_organization, 4);

/**
 * @generated from message raccoonai.OrganizationUpdate
 */
export type OrganizationUpdate = Message<"raccoonai.OrganizationUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional raccoonai.OrganizationStatus status = 3;
   */
  status: OrganizationStatus;

  /**
   * @generated from field: optional uint64 bank_details_id = 4 [json_name = "bank_details_id"];
   */
  bankDetailsId: bigint;

  /**
   * @generated from field: optional string bin = 5;
   */
  bin: string;

  /**
   * @generated from field: optional uint64 primary_contact_id = 6 [json_name = "primary_contact_id"];
   */
  primaryContactId: bigint;

  /**
   * @generated from field: optional string jur_address = 7 [json_name = "jur_address"];
   */
  jurAddress: string;

  /**
   * @generated from field: optional string fact_address = 8 [json_name = "fact_address"];
   */
  factAddress: string;

  /**
   * @generated from field: optional string director_full_name = 9 [json_name = "director_full_name"];
   */
  directorFullName: string;

  /**
   * @generated from field: optional uint64 manager_id = 10 [json_name = "manager_id"];
   */
  managerId: bigint;
};

/**
 * @generated from message raccoonai.OrganizationUpdate
 */
export type OrganizationUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional raccoonai.OrganizationStatus status = 3;
   */
  status?: OrganizationStatusJson;

  /**
   * @generated from field: optional uint64 bank_details_id = 4 [json_name = "bank_details_id"];
   */
  bank_details_id?: string;

  /**
   * @generated from field: optional string bin = 5;
   */
  bin?: string;

  /**
   * @generated from field: optional uint64 primary_contact_id = 6 [json_name = "primary_contact_id"];
   */
  primary_contact_id?: string;

  /**
   * @generated from field: optional string jur_address = 7 [json_name = "jur_address"];
   */
  jur_address?: string;

  /**
   * @generated from field: optional string fact_address = 8 [json_name = "fact_address"];
   */
  fact_address?: string;

  /**
   * @generated from field: optional string director_full_name = 9 [json_name = "director_full_name"];
   */
  director_full_name?: string;

  /**
   * @generated from field: optional uint64 manager_id = 10 [json_name = "manager_id"];
   */
  manager_id?: string;
};

/**
 * Describes the message raccoonai.OrganizationUpdate.
 * Use `create(OrganizationUpdateSchema)` to create a new message.
 */
export const OrganizationUpdateSchema: GenMessage<OrganizationUpdate, {jsonType: OrganizationUpdateJson}> = /*@__PURE__*/
  messageDesc(file_organization, 5);

/**
 * @generated from message raccoonai.OrganizationListRequest
 */
export type OrganizationListRequest = Message<"raccoonai.OrganizationListRequest"> & {
  /**
   * @generated from field: optional raccoonai.OrganizationType type = 1;
   */
  type: OrganizationType;

  /**
   * @generated from field: optional raccoonai.OrganizationStatus status = 2;
   */
  status: OrganizationStatus;

  /**
   * @generated from field: optional string search_query = 3 [json_name = "search_query"];
   */
  searchQuery: string;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.OrganizationListRequest
 */
export type OrganizationListRequestJson = {
  /**
   * @generated from field: optional raccoonai.OrganizationType type = 1;
   */
  type?: OrganizationTypeJson;

  /**
   * @generated from field: optional raccoonai.OrganizationStatus status = 2;
   */
  status?: OrganizationStatusJson;

  /**
   * @generated from field: optional string search_query = 3 [json_name = "search_query"];
   */
  search_query?: string;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.OrganizationListRequest.
 * Use `create(OrganizationListRequestSchema)` to create a new message.
 */
export const OrganizationListRequestSchema: GenMessage<OrganizationListRequest, {jsonType: OrganizationListRequestJson}> = /*@__PURE__*/
  messageDesc(file_organization, 6);

/**
 * @generated from message raccoonai.OrganizationList
 */
export type OrganizationList = Message<"raccoonai.OrganizationList"> & {
  /**
   * @generated from field: repeated raccoonai.Organization organizations = 1;
   */
  organizations: Organization[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.OrganizationList
 */
export type OrganizationListJson = {
  /**
   * @generated from field: repeated raccoonai.Organization organizations = 1;
   */
  organizations?: OrganizationJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.OrganizationList.
 * Use `create(OrganizationListSchema)` to create a new message.
 */
export const OrganizationListSchema: GenMessage<OrganizationList, {jsonType: OrganizationListJson}> = /*@__PURE__*/
  messageDesc(file_organization, 7);

/**
 * The organization and every descendant, for picking a node in the tree.
 *
 * @generated from message raccoonai.OrganizationSubtreeRequest
 */
export type OrganizationSubtreeRequest = Message<"raccoonai.OrganizationSubtreeRequest"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;
};

/**
 * The organization and every descendant, for picking a node in the tree.
 *
 * @generated from message raccoonai.OrganizationSubtreeRequest
 */
export type OrganizationSubtreeRequestJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;
};

/**
 * Describes the message raccoonai.OrganizationSubtreeRequest.
 * Use `create(OrganizationSubtreeRequestSchema)` to create a new message.
 */
export const OrganizationSubtreeRequestSchema: GenMessage<OrganizationSubtreeRequest, {jsonType: OrganizationSubtreeRequestJson}> = /*@__PURE__*/
  messageDesc(file_organization, 8);

/**
 * Organizations where the caller holds action on resource, directly or through an ancestor.
 *
 * @generated from message raccoonai.AccessibleOrganizationListRequest
 */
export type AccessibleOrganizationListRequest = Message<"raccoonai.AccessibleOrganizationListRequest"> & {
  /**
   * e.g. "truck", "job"
   *
   * @generated from field: required string resource = 1;
   */
  resource: string;

  /**
   * can_view (default), can_edit, can_manage
   *
   * @generated from field: optional string action = 2;
   */
  action: string;
};

/**
 * Organizations where the caller holds action on resource, directly or through an ancestor.
 *
 * @generated from message raccoonai.AccessibleOrganizationListRequest
 */
export type AccessibleOrganizationListRequestJson = {
  /**
   * e.g. "truck", "job"
   *
   * @generated from field: required string resource = 1;
   */
  resource?: string;

  /**
   * can_view (default), can_edit, can_manage
   *
   * @generated from field: optional string action = 2;
   */
  action?: string;
};

/**
 * Describes the message raccoonai.AccessibleOrganizationListRequest.
 * Use `create(AccessibleOrganizationListRequestSchema)` to create a new message.
 */
export const AccessibleOrganizationListRequestSchema: GenMessage<AccessibleOrganizationListRequest, {jsonType: AccessibleOrganizationListRequestJson}> = /*@__PURE__*/
  messageDesc(file_organization, 9);

